import H2heading from '@/stories/components/DetailPage/Heading/h2Heading'
import Chicklets from '@/stories/components/DetailPage/Chicklets'
import TraitTable from '@/stories/components/DetailPage/TraitTable'
import classNames from 'classnames'
import { useState } from 'react'
import { TShareholdingPatternV1 } from '@/components/Stocks/Widgets/types'
import Text from '../Common/NewText'

const TransposedDataTable = ({
  details,
}: {
  details: TShareholdingPatternV1 & {
    display_name?: string
    display_subtitle?: string
  }
}) => {
  const { contents = [], display_name, display_subtitle, sliceLength } = details

  const initialState = contents?.map((table, idx) => {
    return {
      title: table.name ?? '',
      selected: idx === 0,
      tables: table.tables?.map((subTable, index) => {
        return {
          ...subTable,
          selected: index === 0,
        }
      }),
    }
  })

  const [transTable, setTransTable] = useState(initialState)

  if (!contents?.length) {
    return null
  }

  const onSelectTransTable = (value: string) => {
    setTransTable(prevStat => {
      return prevStat?.map(item => {
        return {
          ...item,
          selected: item.title === value,
          tables: item.tables?.map((table, index) => {
            return {
              ...table,
              selected: index === 0,
            }
          }),
        }
      })
    })
  }
  const onSelectSubTable = (value?: string) => {
    setTransTable(
      prevStat =>
        prevStat?.map(item => ({
          ...item,
          tables: item.selected
            ? item.tables?.map(table => ({
                ...table,
                selected: table.label === value,
              }))
            : item.tables,
        })),
    )
  }

  return (
    <div>
      {display_name && (
        <H2heading display_name={display_name} as_on={display_subtitle} />
      )}
      {transTable?.length > 1 && (
        <Chicklets data={transTable} onSelect={onSelectTransTable} />
      )}
      {transTable
        .filter(item => item.selected)
        .map(item => {
          return (
            <div
              className="flex flex-row justify-end gap-x-2"
              key={`${item.title}-chicklets`}
            >
              {item.tables?.map((table, idx) => {
                return (
                  item?.tables?.length &&
                  item?.tables?.length > 1 &&
                  table.label && (
                    <Text
                      key={table.label ?? idx}
                      tag="button"
                      appearance="body1"
                      addClassName={classNames('cursor-pointer', {
                        'text-brand-blue-azureRadiance': table.selected,
                        'text-brand-grey-dark': !table.selected,
                      })}
                      onClick={() => onSelectSubTable(table.label)}
                    >
                      {table.label}
                    </Text>
                  )
                )
              })}
            </div>
          )
        })}
      {transTable.map((item, index) => {
        return item.tables
          ?.filter(table => table.selected)
          .map(table => {
            return (
              <div
                key={`${table.label ?? ''}-${index}`}
                className={classNames({
                  block: item.selected,
                  hidden: !item.selected,
                })}
              >
                <TransposeTable data={table} sliceLength={sliceLength} />
              </div>
            )
          })
      })}
    </div>
  )
}

const TransposeTable = ({ data, sliceLength }) => {
  const { table } = data ?? {}

  // Create a map for quick lookup of traits by headerId
  const columnTraitMap = new Map()

  table?.columnHeader?.forEach(header => {
    columnTraitMap.set(header.id, header.trait)
  })
  const columns = table?.rows?.map(item => {
    return {
      ...item,
      columns: item?.columns?.map(subItem => {
        const trait = columnTraitMap.get(subItem.headerId)
        return { ...subItem, trait: trait }
      }),

      subrows: item?.sub_rows?.map(row => {
        return row.map(subItem => {
          const trait = columnTraitMap.get(subItem.headerId)
          return { ...subItem, trait: trait }
        })
      }),
    }
  })

  const traitTable = {
    tableHeading: table?.columnHeader,
    tableContent: columns,
  }
  return (
    <TraitTable
      traitTable={traitTable}
      firstColumnClasses="!min-w-0 "
      sliceLength={sliceLength}
    />
  )
}
export default TransposedDataTable
